import type { Dictionary } from "@/core/i18n";

/**
 * Maps lash/brow validation issue keys to their user-facing dictionary key. Separate from
 * the aesthetics `validationIssueTranslations.ts` because the lash/brow issue vocabulary
 * (eye-region focused) differs. Only the hard-blocking keys surface here — non-blocking
 * warnings never reach the rejected screen.
 */
const LASH_BROW_ISSUE_KEY_TO_TRANSLATION = {
  eye_region_not_visible: "lashBrowSteps.analysis.rejected.issue.eye_region_not_visible",
  no_clear_eye_region_visible: "lashBrowSteps.analysis.rejected.issue.no_clear_eye_region_visible",
  face_obstructed: "lashBrowSteps.analysis.rejected.issue.face_obstructed",
  inappropriate_content: "lashBrowSteps.analysis.rejected.issue.inappropriate_content",
  underage_person: "lashBrowSteps.analysis.rejected.issue.underage_person",
} as const satisfies Record<string, keyof Dictionary>;

const LASH_BROW_REJECTED_FALLBACK_KEY =
  "lashBrowSteps.analysis.rejected.fallback" satisfies keyof Dictionary;

export function getLashBrowValidationIssueTranslationKey(issueKey: string): keyof Dictionary {
  return (
    LASH_BROW_ISSUE_KEY_TO_TRANSLATION[
      issueKey as keyof typeof LASH_BROW_ISSUE_KEY_TO_TRANSLATION
    ] ?? LASH_BROW_REJECTED_FALLBACK_KEY
  );
}
